import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({

  "& .MuiDialogContent-root": {
    padding: 0,
    borderBottom: "solid 1px #B2B2B2",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialogTitle-root": {
    background: "#004F9E",
    color: "#ffffff",
    padding: "8px 16px",
  },
  "& .MuiIconButton-root": {
    padding: "4px",
  },
  "& .MuiDialogActions-root": {
    padding: "15px 27px 10px 25px!important",
    display: "flex",
    justifyContent: "flex-end!important",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#ffffff",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs(props) {
  const { open, onClose, titleText = "", children, mw = "auto", padding = '24px', zIndex = '1300', width = "auto" } = props;

  return (
    <div>
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiDialog-paper': { width: width, maxWidth: "100%", height: "auto", borderRadius: '10px', minWidth: mw, zIndex: zIndex, overflow: 'visible' },
          '& .MuiDialogContent-root': {
            padding: `${padding} !important`
          }
        }}
      >
        {titleText &&
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={onClose}
          >
            {titleText}
          </BootstrapDialogTitle>
        }
        <DialogContent sx={{
          overflow: 'visible', // Set overflow to visible
        }} dividers >{children}</DialogContent>
      </BootstrapDialog>
    </div>
  );
}
